<template>
  <v-sheet class="pa-4 mb-4">
    <p class="text-body-2 text--secondary mb-2">
      特定の車両に絞って表示することができます。
    </p>
    <!-- div class="d-flex align-baseline" -->
    <div class="CCarFilters">

      <div class="CCarFilters_Item">
        <div class="CCarFilters_caption text--secondary mr-4">車両タイプ</div>
        <v-select
          class="CCarFilters_select"
          v-model="filters.carType"
          :items="carTypes"
          dense hide-details
        />
      </div>

      <div class="CCarFilters_Item">
        <div class="CCarFilters_caption text--secondary mr-4"
          v-show="enableCar24Flg"
        >
          24時間対応
        </div>
        <v-select
          class="CCarFilters_select"
          ref="CCarFilters_select_car24Flg"
          v-show="enableCar24Flg"
          v-model="filters.car24Flg"
          :items="car24Flg"
          dense hide-details
          @click="onClick"
        />
      </div>

      <div class="CCarFilters_Item">
        <div
          v-show="enableCar24Flg"
          class="CCarFilters_vkey"
        >
          <a :href="'/reserve/res/' + orgcode + '/vkey.pdf'">24時間貸出車両について</a>
        </div>
      </div>

    </div>
  </v-sheet>
</template>

<style>
@media screen and (min-width: 1024px) {
  .CCarFilters {
    display: flex!important;
  }
  .CCarFilters_Item {
    width: 32%;
  }
  .CCarFilters_select {
    width: 80%!important;
  }
  .CCarFilters_vkey > a {
    width: 50%;
  }
}
@media screen and (max-width: 1023px) {
  .CCarFilters {
    display: block;
  }
  .CCarFilters_Item {
    width: 100%;
  }
  .CCarFilters_select {
    width: 60%!important;
  }
  .CCarFilters_vkey > a {
    width: 80%;
  }
}

.CCarFilters {
  width: 100%;
}
.CCarFilters_Item {
  display: inline-block;
}
.CCarFilters_caption {
  float: left;
  line-height: 26px!important;
  margin-top: 5px;
  font-size: 0.75rem!important;
  width: 4rem;
}
.CCarFilters_select {
  float: left;
}
.CCarFilters_vkey {
  width: 100%;
}
.CCarFilters_vkey > a {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 15px;
  border: 1px #cccccc solid;
  text-decoration: none;
  text-align: center;
}
</style>

<script>
import * as time from '@/libs/time'

export default {
  name: 'CCarFilters',

  props: {
    filters: {
      type: Object,
      required: true
    },
    enableCar24Flg: {
      type: Boolean,
      default: false
    },
    orgcode: String
  },

  data: () => ({
    today: time.today()
  }),

  computed: {
    carTypes () {
      const types = this.getters['org/carTypes']

      return [
        { text: 'すべて', value: '' },

        ...types.map(item => ({
          text: item.name,
          value: item.code
        }))
      ]
    },
    car24Flg () {
      return [
        { text: 'すべて', value: '' },
        { text: '24時間貸出対応車両のみ', value: 1 }
      ]
    },
    /**
     * ログインしているか
     */
    authed () {
      return this.getters['user/authed']
    },
    /**
     * 初回利用フラグ
     */
    firstTime () {
      return this.getters['user/limited'](this.today).firstTime
    },
    /**
     * 24時間利用可能フラグ
     */
    user24Flg () {
      return this.getters['user/keykey']
    }
  },

  methods: {
    onClick () {
      if (!this.authed) { // 未ログイン状態
        alert('24時間車両は、ログインしてからご利用ください')
        this.$refs.CCarFilters_select_car24Flg.blur() // フォーカスを外す
      } else if (this.firstTime) { // 初回利用時
        const orgcode = this.getters['org/code']
        if (orgcode === 'sagami-rent') {
          return false
        }
        alert('24時間車両は、初回利用のお客様はご利用いただけません')
        this.$refs.CCarFilters_select_car24Flg.blur() // フォーカスを外す
      } else if (!this.user24Flg) { // 24時間車両利用不可
        alert('お客様は24時間車両がご利用できないステータスになっております')
        this.$refs.CCarFilters_select_car24Flg.blur() // フォーカスを外す
      }
    }
  }
}
</script>
